import { Box, Typography } from "@mui/material";
import {
  Divider,
  TextFieldCust,
  ButtonCust,
  SimpleModal,
} from "../../../widgets";
import styles from "./NewNumberModal.module.scss";
import { useAppSelector } from "../../../../app/hooks";
import { gaCategory } from "../../../../Types/GoogleAnalytics";
import Config from "../../../../config/env.config.json";

type InewNumberProps = {
  open: boolean;
  onClose: any;
  content: any;
  GAAndFBEventsHandler: any;
  zipCodeformik: any;
  zipcodeChangeHandler: any;
  currentLine?: any;
};

export const NewNumberModal = (props: InewNumberProps) => {
  const {
    open,
    onClose,
    content,
    GAAndFBEventsHandler,
    zipCodeformik,
    zipcodeChangeHandler,
  } = props;

  const { zipCodeStatus, zipCodeLoader } = useAppSelector(
    (state: any) => state?.activation || {}
  );
  const { title, desc, zc_ph, zc_btn, msgs } = content?.zp_md;
  const { isValid } = zipCodeStatus || {};
  const closeIconSt = {
    position: "absolute",
    right: "-15px",
  };
  return (
    <SimpleModal
      isShowModal={open}
      onCloseModal={onClose}
      showClose={true}
      className={styles.new_num_modal}
      sx={{
        borderRadius: content?.du_w_nn ? "10px !important" : "4.8px",
        maxWidth: { xs: "95%", sm: content?.du_w_nn ? "650px" : "500px" },
        top: "50%",
        left: "50%",
        width: content?.du_w_nn
          ? { xs: "90%", sm: "70%", md: "80%", lg: "48%", xl: "42%" }
          : "500px !important",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
      }}
      closeIconSt={closeIconSt}
    >
      <Box className={styles.dialog_main}>
        <Typography
          className={styles.dialog_heading}
          sx={{
            mb: {
              xs: "10px !important",
              sm: "25px !important",
            },
            fontSize: {
              xs: content?.du_w_nn ? "18px !important" : "initial",
              sm: content?.du_w_nn ? "24px !important" : "initial",
            },
            lineHeight: {
              xs: content?.du_w_nn ? "30px !important" : "initial",
              sm: content?.du_w_nn ? "36px !important" : "initial",
            },
            color: content?.du_w_nn ? "var(--black) !important" : "initial",
          }}
        >
          {title}
        </Typography>
        {/* <Divider /> */}
        <Typography
          sx={{
            fontFamily: "var(--font_family_Regular)",
            mb: "25px",
            fontSize: {
              xs: content?.du_w_nn ? "14px !important" : "14px",
              sm: content?.du_w_nn ? "18px !important" : "16px",
            },
            lineHeight: {
              xs: content?.du_w_nn ? "24px !important" : "initial",
              sm: content?.du_w_nn ? "28px !important" : "initial",
            },
          }}
          width={{ xs: "100%", sm: "75%" }}
        >
          {msgs?.desc_sec
            ? props?.currentLine?.isPrimary
              ? desc
              : msgs.desc_sec
            : desc}
        </Typography>
        <Box
          width="100%"
          display="flex"
          flexDirection="column"
          className={styles.textField_limit_container}
        >
          <Box sx={{ width: { xs: "100%", sm: "75%" }, alignSelf: "center" }}>
            <TextFieldCust
              placeholder={zc_ph}
              maxLength={5}
              name="zipCode"
              value={zipCodeformik.values.zipCode}
              onChange={(e) => zipcodeChangeHandler(e)}
              error={
                zipCodeformik.errors?.zipCode || isValid === false
                  ? true
                  : false
              }
              helperText={
                zipCodeformik.errors?.zipCode ||
                (isValid === false && msgs?.invalid_msg)
              }
              onKeyUp={(e: any) => {
                if (e.key === "Enter") {
                  zipCodeformik.handleSubmit();
                }
              }}
            />
          </Box>
          <Typography
            sx={{
              color: "var(--black)",
              alignSelf: "center",
              width: { xs: "100%", sm: "75%" },
            }}
            className={
              content?.du_w_nn ? styles?.limit_text_next : styles.limit_text
            }
          >
            {zipCodeformik.values.zipCode?.length}/5
          </Typography>
        </Box>
        <ButtonCust
          variantType={Config.PRIMARY_BUTTON_TYPE}
          sx={{
            width: content?.du_w_nn ? "250px" : "inherit",
            // padding: "13px 23px",
            // height: "50px !important",
            // fontSize: "18px !important",
            mb: '10px'
          }}
          onClick={() => {
            zipCodeformik.handleSubmit();
            GAAndFBEventsHandler(gaCategory.activation, "Check ZIP Code");
          }}
          disabled={
            zipCodeformik.values?.zipCode.length === 0
              ? true
              : !zipCodeformik?.isValid
          }
          loading={zipCodeLoader}
        >
          {zc_btn}
        </ButtonCust>
      </Box>
    </SimpleModal>
  );
};
